import firebase from "firebase"

const firebaseConfig = {
  apiKey: "AIzaSyBlap1vT1_b-VXvTLCCaPE8HriMx2ylSmc",
  authDomain: "one-p-b4b54.firebaseapp.com",
  projectId: "one-p-b4b54",
  storageBucket: "one-p-b4b54.appspot.com",
  messagingSenderId: "441265361712",
  appId: "1:441265361712:web:72dbba736ee200dcf6aef5",
  measurementId: "G-FFPYE2G7XY",
}

const createOtherUser = async (email, password) => {
  const secondaryApp = firebase.initializeApp(firebaseConfig, "secondary")
  let userId = ""

  const createUserAuth = async () => {
    await secondaryApp
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(async userCredential => {
        userId = userCredential.user.uid
        return userCredential.user.uid
      })
      .then(async () => {
        try {
          secondaryApp.auth().signOut()
        } catch (e) {}
      })
      .then(async () => {
        try {
          secondaryApp.delete()
        } catch (e) {}
      })
      .catch(async e => {
        secondaryApp.delete()
      })
  }
  await createUserAuth()
  return userId
}

export default createOtherUser
